import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import api, { formatApiError } from "@/lib/api";
import Brand from "@/components/Brand";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Checkbox } from "@/components/ui/checkbox";
import { Loader2, Check, Lock } from "lucide-react";

export default function ClientSignup() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [consent, setConsent] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (!consent) { setError("Aceite os Termos e a Política de Privacidade."); return; }
    setError(""); setLoading(true);
    try {
      await register({ ...form, role: "client", consent });
      navigate("/app/encontrar");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-6">
      <div className="w-full max-w-md">
        <Link to="/"><Brand className="mb-8 justify-center" /></Link>
        <div className="rounded-2xl border border-border bg-card p-8">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent/10 text-accent text-xs font-medium mb-4">
            <Lock className="w-3.5 h-3.5" /> Acesso do Cliente
          </div>
          <h1 className="font-heading text-2xl font-semibold tracking-tight">Crie sua conta de cliente</h1>
          <p className="text-muted-foreground mt-2 text-sm">
            Encontre um hipnoterapeuta por região (inclusive quem atende online) e agende sua consulta. Você também acessa conteúdos:
          </p>
          <ul className="mt-3 space-y-1 text-sm">
            <li className="flex items-center gap-2"><Check className="w-4 h-4 text-accent" />Conteúdos gratuitos liberados na hora</li>
            <li className="flex items-center gap-2"><Check className="w-4 h-4 text-accent" />Vitrine de conteúdos premium para compra avulsa</li>
          </ul>

          <form onSubmit={submit} className="mt-6 space-y-4">
            <div><Label htmlFor="n">Nome</Label><Input id="n" value={form.name} onChange={set("name")} required data-testid="cs-name" className="mt-1.5" /></div>
            <div><Label htmlFor="e">E-mail</Label><Input id="e" type="email" value={form.email} onChange={set("email")} required data-testid="cs-email" className="mt-1.5" /></div>
            <div><Label htmlFor="p">Senha</Label><Input id="p" type="password" value={form.password} onChange={set("password")} required data-testid="cs-password" className="mt-1.5" /></div>
            <label className="flex items-start gap-2 text-sm text-muted-foreground">
              <Checkbox checked={consent} onCheckedChange={setConsent} data-testid="cs-consent" className="mt-0.5" />
              <span>Li e aceito os Termos de Uso e a Política de Privacidade (LGPD).</span>
            </label>
            {error && <p className="text-sm text-destructive" data-testid="cs-error">{error}</p>}
            <Button type="submit" className="w-full rounded-full h-11" disabled={loading} data-testid="cs-submit">
              {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Criar conta e encontrar profissional"}
            </Button>
          </form>
          <p className="mt-5 text-xs text-muted-foreground text-center">
            É hipnoterapeuta? <Link to="/cadastro" className="text-primary font-medium">Cadastre-se aqui</Link> ·
            Já tem conta? <Link to="/login" className="text-primary font-medium">Entrar</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
